// @flow
import type { Config, CarEntity, Car } from '../../types';
import useNow from '../../hooks/useNow';
import { isActive } from '../../utils/targetUtils';


export type Props = $ReadOnly<{
    sessionConfig: $PropertyType<Config, 'session'>,
    icao: string,
    entity: CarEntity,
    car: Car,

    endSession: (icao: string) => void
}>;

function SyncCar({ sessionConfig, icao, entity, car, endSession }: Props) {
    useNow();

    if(typeof entity.sessionStart !== 'undefined' && !isActive(car.TimeOfTrackInformation, sessionConfig)) {
        endSession(icao);
    }

    return null;
}

export default SyncCar;